/**
 * Copyright (c) 2026 Constructor Technology AG. All rights reserved.
 *
 * Proprietary and confidential. Unauthorized copying, distribution, or use
 * is prohibited.
 *
 * SPDX-License-Identifier: LicenseRef-Constructor-Proprietary
 */

const TOKEN_KEY = 'hmsAuthToken'

export const getAuthToken = () => localStorage.getItem(TOKEN_KEY)

export const removeAuthToken = () => localStorage.removeItem(TOKEN_KEY)

export const setAuthToken = token => localStorage.setItem(TOKEN_KEY, token)
